import FooterNavbar from "../../../footernavbar/FooterNavbar";
import OurWorkplaceNavbar from "./OurWorkplaceNavbar";

const Diversity = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <OurWorkplaceNavbar />
        <div>
          <div className="py-3">
            <div>
              <div className="mt-3">
                <div className="row">
                  <div className="container">
                    <div className="col-lg-12 justify-content-center text-center ">
                      <h1 className=" text-black source-serif-4 text-normal mt-2">
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-l text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                        Embracing Diversity, Equity, & Inclusion{" "}
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-r text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="w-60 h-50 mx-auto mt-4">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/footer/ede-1.jpg"
                      alt="img-blur-shadow-blog-2"
                      className="img-full "
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
              <div className="row w-70 d-flex justify-content-center mx-auto pt-4">
                <section className="py-0">
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="container col-lg-12  col-md-6 position-relative mb-sm-0 mb-3">
                        <p className="mb-3 fs-4 container text-black">
                          At Sworld solutions private limited, we believe that a
                          diverse, equitable, and inclusive workplace is not
                          just a moral imperative but a business necessity. In
                          the dynamic world of ecommerce, where innovation and
                          creativity are the driving forces, fostering an
                          environment where every voice is heard, respected, and
                          valued is crucial for our success.
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="py-5">
                  <div className="container">
                    <div className="row">
                      <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-l text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                        Diversity: Our Strength in Variety
                        <sup>
                          <i
                            className="ri-double-quotes-r text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                      </h1>
                      <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                        <div className="mb-3">
                          <p className="mb-3 fs-3 container text-black">
                            Diversity is about acknowledging, respecting, and
                            celebrating differences. At Sworld, we strive to
                            build a team that reflects the varied perspectives
                            of our global customer base. By welcoming
                            individuals from different backgrounds, cultures,
                            and experiences, we ensure that our products and
                            services cater to a wide range of needs and
                            preferences. This diversity enhances our creativity
                            and drives innovation, enabling us to solve problems
                            more effectively and connect with our customers on a
                            deeper level.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-1"></div>
                      <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                        <img
                          className="w-100 border-radius-lg shadow"
                          src="../../assets/img/footer/ede-3.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </section>
                <section className="py-5">
                  <div className="container">
                    <div className="row">
                      <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                        <sup>
                          <i
                            className="ri-double-quotes-l text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                        Equity: Ensuring Fairness and Opportunity
                        <sup>
                          <i
                            className="ri-double-quotes-r text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                      </h1>
                      <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                        <img
                          className="w-100 border-radius-lg shadow"
                          src="../../assets/img/footer/ede-4.jpg"
                          alt=""
                        />
                      </div>
                      <div className="col-lg-1"></div>
                      <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                        <div className="mb-3">
                          <p className="mb-3 fs-3 container text-black">
                            Equity means creating an environment where everyone
                            has access to the same opportunities. At Sworld, we
                            are committed to ensuring that all employees have
                            the resources and support they need to succeed. This
                            includes equitable hiring practices, transparent
                            career advancement paths, and equal access to
                            training and development programs. By actively
                            working to remove barriers and biases, we create a
                            level playing field where all team members can
                            thrive and reach their full potential.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="py-5">
                  <div className="container">
                    <div className="row">
                      <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-l text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                        Inclusion: Cultivating a Sense of Belonging
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-r text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                      </h1>
                      <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                        <div className="mb-3">
                          <p className="mb-3 fs-3 container text-black">
                            Inclusion is about creating a workplace where
                            everyone feels welcomed and valued. We foster a
                            culture of inclusion by encouraging open
                            communication, promoting collaboration, and ensuring
                            that all voices are heard. Our inclusive practices
                            extend beyond our internal team to our interactions
                            with customers, suppliers, and partners. We strive
                            to create an environment where diversity is
                            embraced, and everyone feels a sense of belonging
                            and purpose.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-1"></div>
                      <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                        <img
                          className="w-100 border-radius-lg shadow"
                          src="../../assets/img/footer/ede-6.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </section>
                <section className="py-5">
                  <div className="container">
                    <div className="row">
                      <h1 className=" text-black source-serif-4 justify-content-center text-center mb-6 text-normal mt-2">
                        <sup>
                          <i
                            className="ri-double-quotes-l text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                        Our Commitment to DE&I
                        <sup>
                          {" "}
                          <i
                            className="ri-double-quotes-r text-dark text-5xl"
                            aria-hidden="true"
                          ></i>{" "}
                        </sup>
                      </h1>
                      <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                        <img
                          className="w-100 border-radius-lg shadow"
                          src="../../assets/img/footer/ede-5.jpg"
                          alt=""
                        />
                      </div>
                      <div className="col-lg-1"></div>
                      <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                        <div className="mb-2">
                          <h3 className="mb-3 text-black fw-bold">
                            1. Recruitment and Hiring :
                          </h3>
                          <p className="mb-3 fs-5 container text-black">
                            We are dedicated to attracting diverse talent by
                            implementing unbiased recruitment processes and
                            partnering with organizations that support
                            underrepresented groups.
                          </p>
                        </div>
                        <div>
                          <h3 className="mb-3 text-black fw-bold ">
                            2. Employee Development :
                          </h3>
                          <p className="mb-3 fs-5 container text-black">
                            We offer ongoing training and development
                            opportunities to ensure that all employees have the
                            skills and knowledge to advance their careers.
                          </p>
                        </div>
                        <div>
                          <h3 className="mb-3 text-black fw-bold ">
                            3. Inclusive Culture :
                          </h3>
                          <p className="mb-3 fs-5 container text-black">
                            We promote a culture of inclusion through regular
                            team-building activities, open forums for
                            discussion, and employee resource groups.
                          </p>
                        </div>
                        <div>
                          <h3 className="mb-3 text-black fw-bold ">
                            4. Community Engagement :
                          </h3>
                          <p className="mb-3 fs-5 container text-black">
                            We actively engage with and support communities that
                            reflect our commitment to diversity, equity, and
                            inclusion.
                          </p>
                        </div>
                        <div>
                          <h3 className="mb-3 text-black fw-bold ">
                            5. Accountability :
                          </h3>
                          <p className="mb-3 fs-5 container text-black">
                            We regularly review our DE&I initiatives and measure
                            our progress to ensure that we are meeting our goals
                            and continuously improving.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="py-6">
                  <div className="row">
                    <div className="container">
                      <div className="col-lg-12 justify-content-center text-center ">
                        <h1 className=" text-black source-serif-4 text-normal mt-2">
                          <sup>
                            {" "}
                            <i
                              className="ri-double-quotes-l text-dark text-5xl"
                              aria-hidden="true"
                            ></i>{" "}
                          </sup>
                          Unity, Respect, Empowerment
                          <sup>
                            {" "}
                            <i
                              className="ri-double-quotes-r text-dark text-5xl"
                              aria-hidden="true"
                            ></i>{" "}
                          </sup>
                        </h1>
                        <h4 className=" text-black source-serif-4 text-normal mt-2">
                          <sup>
                            {" "}
                            <i
                              className="ri-double-quotes-l text-dark text-lg"
                              aria-hidden="true"
                            ></i>{" "}
                          </sup>
                          At Sworld solutions private limited,, we understand
                          that our strength lies in our diversity and our
                          commitment to equity and inclusion. <br />
                          By embracing these values, we not only create a better
                          workplace but also deliver better products and
                          services to our customers. <br /> Together, we are
                          building a company that is not only successful but
                          also a force for positive change in the world.
                          <sup>
                            <i
                              className="ri-double-quotes-r text-dark text-lg"
                              aria-hidden="true"
                            ></i>{" "}
                          </sup>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="w-80 h-50 mx-auto mt-4">
                    <div className="d-block blur-shadow-image">
                      <img
                        src="../../assets/img/footer/ede-2.jpeg"
                        alt="img-blur-shadow-blog-2"
                        className="img-full "
                        loading="lazy"
                      />
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Diversity;
